import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import { Lead } from "../v1/Lead";
import {
  MrfiktivCreateLeadDtoGen,
  MrfiktivLeadControllerFindAllParamsGen,
  MrfiktivUpdateLeadDtoGen
} from "../v1/data-contracts";

/**
 * Communicate with lead API
 */
class LeadService {
  mrfiktivProxy: Lead;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.mrfiktivProxy = new Lead(mrfiktivHttpClientProvider.client());
  }

  /**
   * Create a lead
   */
  async create(partnerId: string, data: MrfiktivCreateLeadDtoGen) {
    const lead = (await this.mrfiktivProxy.leadControllerCreate(partnerId, data)).data;

    return lead;
  }

  /**
   * Get all leads
   */
  async get(data: MrfiktivLeadControllerFindAllParamsGen) {
    const leads = (await this.mrfiktivProxy.leadControllerFindAll(data)).data;

    return leads;
  }

  /**
   * Get a lead
   */
  async getOne(partnerId: string, leadId: string) {
    const lead = (await this.mrfiktivProxy.leadControllerGetOne(partnerId, leadId)).data;

    return lead;
  }

  /**
   * Update a lead
   */
  async update(partnerId: string, leadId: string, data: MrfiktivUpdateLeadDtoGen) {
    const lead = (await this.mrfiktivProxy.leadControllerUpdate(partnerId, leadId, data)).data;

    return lead;

  }

  /**
   * Delete a lead
   */
  async delete(partnerId: string, leadId: string) {
    const lead = (await this.mrfiktivProxy.leadControllerDelete(partnerId, leadId)).data;

    return lead;
  }
}

/**
 * Communicate with lead API
 */
export default new LeadService(new MrfiktivHttpClientProvider());
